module.exports = __webpack_public_path__ + "static/media/template7.9722c97c.webp";